import { z } from 'zod';
import { FormFieldDTO } from '../FormDTO';

export const ProductFormDTO = z.object({
    id: z.string(),
    name: z.string(),
    imageUrl: z.string().url().optional(),
    brand: z.object({
        id: z.string().optional(),
        name: z.string(),
    }),
});

export const ProductFormTemplateDTO = z.object({
    form: z.object({
        product: ProductFormDTO,
        fields: z.array(FormFieldDTO),
    }),
});

export type ProductFormDTO = z.infer<typeof ProductFormDTO>;
export type ProductFormTemplateDTO = z.infer<typeof ProductFormTemplateDTO>;
